import { arrayRequired, labeled, stringOptional } from '../../util/joi';
import { schema as reviewProductSchema } from './HomeLoanReviewProduct.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    idLender: stringOptional(Joi, 1, 64),
    productSplits: Joi.when('idLender', {
      is: '48e3d546cc6279dadae4ab3dace3ecd661cff2e1e6c2d79eddea12ff017503a6',
      then: arrayRequired(Joi, reviewProductSchema(Joi, labeled(label, 'Product Split -')))
        .min(1)
        .label(labeled(label, 'Product Split -'))
    }).when('idLender', {
      is: 'a422e5e5a235a545d128c0f698e9cebe40b78cc484bf254046cd3421262e9de9',
      then: arrayRequired(Joi, reviewProductSchema(Joi, labeled(label, 'Product Split -')))
        .min(1)
        .label(labeled(label, 'Product Split -'))
    })
  });

export default {
  schema
};
